import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { api } from "@/lib/api";


const AuthContext = createContext(null);


export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [sessionLoading, setSessionLoading] = useState(true);

  const refreshSession = useCallback(async () => {
    setSessionLoading(true);
    try {
      const response = await api.get("/auth/session");
      setSession(response.data?.authenticated ? response.data : null);
    } catch (_error) {
      setSession(null);
    } finally {
      setSessionLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setSession(null);
  }, []);

  const value = useMemo(
    () => ({
      session,
      sessionLoading,
      refreshSession,
      logout,
      setSession,
    }),
    [logout, refreshSession, session, sessionLoading, setSession],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};